'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getDefaultCheckState = function (defaultCheckedValues) {
    var defaultChecked = {};
    defaultCheckedValues.forEach(function (v) {
        defaultChecked["" + v] = true;
    });
    return defaultChecked;
};

exports.getDefaultCheckState = getDefaultCheckState;
